import React, { useMemo } from 'react';
import GenericPullConfigListing from '../GenericPullConfigListing';
import FortifyCredentialsForm from './FortifyCredentialsForm';
import FortifyMappingForm from './FortifyMappingForm';
import { CellRenderers } from 'utils/tableUtils';
import _ from 'lodash';
import ContentOverlay from 'components/ContentOverlay';


const FortifyConfigListing = (props) => {
    const columns = useMemo(() => [{
        title: "Project",
        dataIndex: "applicationName",
        width: 240,
        render: (project, record) => {
            if(_.isEmpty(project)) {
                return CellRenderers.VALUE_OR_NA(project)
            }
            const releaseObj = {}
            if (record.releaseName) {
              const releaseNameArray = _.split(record.releaseName, ',')
              _.forEach(releaseNameArray, release => {
                let [_projectName, _releaseName] = _.split(release, ':')
                _releaseName = _.split(_releaseName.replace(/;/g, ','), ',');
                releaseObj[_projectName] = _releaseName
              })
            }
            const renderName = project.split(',').map(item => <p>{releaseObj[item] ? `${item} - [${releaseObj[item]}]` : item}</p>)
            return <ContentOverlay content={renderName} minHeight={40}/>
        } 
    }], [])

    return (
    <GenericPullConfigListing
        {...props}
        toolName={props.name}
        MappingForm={FortifyMappingForm}
        CredentialsForm={FortifyCredentialsForm}
        extraColumns={columns}
     />
);
}

export default FortifyConfigListing;
